import React from 'react';
import { OnboardingCard, OnboardingContainer, OnboardingContent, OnboardingH1, OnboardingHeader } from '@pages/phases/Phases.styles';
import { Box, SvgIcon } from '@agilize/components-core';
import { ButtonHelpDesk } from '@pages/FinishPage/FinishPage.styles';
import Helpdesk from '@components/Helpdesk/Helpdesk';
import { FinishTitle, FinishSubtitle } from './LeadNotFound.styles';

const LeadNotFound = () => (
  <OnboardingContainer>
    <OnboardingContent>
      <OnboardingCard>
        <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
          <SvgIcon width={250} height={250} src={`${process.env.APP_PATH}public/assets/images/question-agent.svg`} />
          <FinishTitle>Oops!</FinishTitle>
          <FinishSubtitle>Parece que seus dados ainda não foram processados para que você tenha acesso ao sistema.</FinishSubtitle>
          <FinishSubtitle>
            Caso haja algum problema ou dúvida acesse nossa
            <br />
            <ButtonHelpDesk>
              <Helpdesk>página de suporte</Helpdesk>.
            </ButtonHelpDesk>
          </FinishSubtitle>
        </Box>
      </OnboardingCard>
    </OnboardingContent>
  </OnboardingContainer>
);

export default LeadNotFound;
